// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		styleScrollToTop: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: true
	},
};

(function() {
	BoostPFS.inject(this);

	// --- Badges custom : premier écran + pagination / scroll Boost PFS ---
	if (typeof window.__boostPFSBadgeHtmlById === 'undefined') window.__boostPFSBadgeHtmlById = {};
	if (typeof window.__boostPFSBadgeTextByHandle === 'undefined') window.__boostPFSBadgeTextByHandle = {};
	if (typeof window.__boostPFSBadgeFetchByHandle === 'undefined') window.__boostPFSBadgeFetchByHandle = {};

	function boostPFSGetShopifyRoot() {
		if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
		return '/';
	}

	function boostPFSGetThemeBadgeStyleAttr() {
		var c = (typeof boostPFSConfig !== 'undefined' && boostPFSConfig.custom) ? boostPFSConfig.custom : {};
		var bg = c.badge_color_bg || '#000000';
		var fg = c.badge_color_text || '#ffffff';
		var rad = c.badge_border_radius != null ? c.badge_border_radius : 0;
		return '--badge-color-bg: ' + bg + '; --badge-color-text: ' + fg + '; --badge-border-radius: ' + rad + 'px;';
	}

	function boostPFSEscapeHtml(s) {
		return String(s)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	function boostPFSEscapeAttr(s) {
		return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
	}

	function boostPFSGetProductHandle(data) {
		if (!data) return '';
		if (data.handle) return String(data.handle);
		if (data.product_handle) return String(data.product_handle);
		try {
			if (typeof Utils !== 'undefined' && Utils.buildProductItemUrl) {
				var u = Utils.buildProductItemUrl(data);
				if (u) {
					var path = String(u).split('?')[0].replace(/\/$/, '');
					var seg = path.split('/').pop();
					return seg || '';
				}
			}
		} catch (e) {}
		return '';
	}

	function boostPFSExtractBadgeTextFromData(data) {
		if (!data || typeof data !== 'object') return '';
		try {
			var keys = ['badge_produit', 'badge_text', 'badgeProduit', 'custom_badge_produit'];
			for (var i = 0; i < keys.length; i++) {
				if (data[keys[i]] != null && String(data[keys[i]]).trim() !== '') return String(data[keys[i]]);
			}
			if (data.metafields && data.metafields.custom && data.metafields.custom.badge_produit != null) {
				var v = data.metafields.custom.badge_produit;
				return v.value != null ? String(v.value) : String(v);
			}
			for (var k in data) {
				if (!Object.prototype.hasOwnProperty.call(data, k)) continue;
				if (k.indexOf('badge') !== -1 && typeof data[k] === 'string' && data[k].trim()) return data[k];
			}
		} catch (e2) {}
		return '';
	}

	function boostPFSBuildBadgeHtml(productId, text) {
		if (!text) return '';
		var t = String(text).trim();
		if (!t) return '';
		var id = String(productId);
		return '<span class="product-badge" data-product-id="' + boostPFSEscapeAttr(id) + '" style="' + boostPFSGetThemeBadgeStyleAttr() + '">' + boostPFSEscapeHtml(t) + '</span>';
	}

	function boostPFSBuildBadgePlaceholder(productId, handle) {
		if (!handle) return '';
		return '<span class="product-badge product-badge--pending" data-product-id="' + boostPFSEscapeAttr(String(productId)) + '" data-product-handle="' + boostPFSEscapeAttr(handle) + '" style="position:absolute;width:0;height:0;overflow:hidden;margin:0;padding:0;border:0;" aria-hidden="true"></span>';
	}

	function boostPFSFillPendingBadges() {
		if (typeof document === 'undefined') return;
		var nodes = document.querySelectorAll('.product-badge--pending');
		var needFetch = [];
		var seenFetch = {};
		for (var i = 0; i < nodes.length; i++) {
			var sp = nodes[i];
			var handle = sp.getAttribute('data-product-handle');
			if (!handle) continue;
			if (Object.prototype.hasOwnProperty.call(window.__boostPFSBadgeTextByHandle, handle)) {
				var cached = window.__boostPFSBadgeTextByHandle[handle];
				var pid = sp.getAttribute('data-product-id');
				var html = cached && String(cached).trim() ? boostPFSBuildBadgeHtml(pid, cached) : '';
				if (html && sp.parentNode) {
					var wrap = document.createElement('div');
					wrap.innerHTML = html;
					var badge = wrap.firstElementChild;
					if (badge) {
						sp.parentNode.replaceChild(badge, sp);
						if (window.__boostPFSBadgeHtmlById && pid) window.__boostPFSBadgeHtmlById[pid] = badge.outerHTML;
					}
				} else {
					sp.remove();
				}
				continue;
			}
			if (!window.__boostPFSBadgeFetchByHandle[handle] && !seenFetch[handle]) {
				seenFetch[handle] = true;
				needFetch.push(handle);
			}
		}
		for (var j = 0; j < needFetch.length; j++) {
			(function (handle) {
				var root = boostPFSGetShopifyRoot();
				window.__boostPFSBadgeFetchByHandle[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '?view=badge-produit', { credentials: 'same-origin' })
					.then(function (r) { return r.text(); })
					.then(function (txt) {
						try {
							var parsed = JSON.parse(String(txt).trim());
							return parsed == null ? '' : String(parsed);
						} catch (e) {
							return '';
						}
					})
					.catch(function () { return ''; })
					.then(function (text) {
						window.__boostPFSBadgeTextByHandle[handle] = text || '';
						boostPFSFillPendingBadges();
					});
			})(needFetch[j]);
		}
	}

	function boostPFSInitBadgeObserver() {
		if (window.__boostPFSBadgeObserverInit) return;
		window.__boostPFSBadgeObserverInit = true;
		var t = null;
		try {
			var obs = new MutationObserver(function () {
				clearTimeout(t);
				t = setTimeout(boostPFSFillPendingBadges, 80);
			});
			obs.observe(document.documentElement, { childList: true, subtree: true });
		} catch (e) {}
	}
	boostPFSInitBadgeObserver();

	// Cache le HTML des badges custom déjà rendus au départ.
	// Ensuite, Boost PFS reconstruit des cartes côté JS: sans ça, le badge disparaît.
	function boostPFSCacheBadgesFromDOM() {
		try {
			var nodes = document.querySelectorAll('.product-badge[data-product-id]');
			for (var i = 0; i < nodes.length; i++) {
				var el = nodes[i];
				var pid = el.getAttribute('data-product-id');
				if (pid) window.__boostPFSBadgeHtmlById[pid] = el.outerHTML;
			}
		} catch (e) {
			// Ignore: si le DOM n'est pas prêt ou si querySelectorAll échoue.
		}
	}
	function boostPFSOnDomReadyBadges() {
		boostPFSCacheBadgesFromDOM();
		setTimeout(boostPFSFillPendingBadges, 0);
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boostPFSOnDomReadyBadges);
	} else {
		boostPFSOnDomReadyBadges();
	}
	
	ProductGridItem.prototype.compileTemplate = function(data) {
		if(!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
		
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var aspect_ratio = '';
		var itemImagesHtml = '<div class="products-container-image">';
		itemImagesHtml += '<img ' +
			'class="card_container-img lazyload" ' +
			'src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
			'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
			'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-sizes="auto" ' +
			`alt="${data.title}">`;
		
		// Badge custom : cache premier écran, champ data Boost, ou fetch async (scroll / pagination).
		var badgeHtml = window.__boostPFSBadgeHtmlById ? window.__boostPFSBadgeHtmlById[data.id] : '';
		if (!badgeHtml) {
			var bt = boostPFSExtractBadgeTextFromData(data);
			if (bt) {
				badgeHtml = boostPFSBuildBadgeHtml(data.id, bt);
				if (badgeHtml) window.__boostPFSBadgeHtmlById[data.id] = badgeHtml;
			}
		}
		if (!badgeHtml) {
			var h = boostPFSGetProductHandle(data);
			if (h) badgeHtml = boostPFSBuildBadgePlaceholder(data.id, h);
		}
		if (badgeHtml) itemImagesHtml += badgeHtml;

		itemImagesHtml += '</div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		{ data.title.split(' - ')[1] != undefined ? 
			itemHtml = itemHtml.replace(/{{itemTitle}}/g, `<h2 class="h3-card_product">${data.title.split(' - ')[0]}</h2><span class='color-sswatch'>${data.title.split(' - ')[1]}</span>`)
			:
			itemHtml = itemHtml.replace(/{{itemTitle}}/g, `<h2 class="h3-card_product">${data.title.split(' - ')[0]}</h2>`);
		}
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		setTimeout(boostPFSFillPendingBadges, 0);
		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
	
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;
	
		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);
	
		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
	
		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
	
		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);
	
		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
	
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
	
		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';
	
		priceHtml += '<dl class="price-mina' + onSaleClass + '" data-price>';
		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item-mina-card price-item--regular" data-regular-price>';
		if (data.available) {
			if (onSale) {
				priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat);
			} else {
				priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
		} else {
			//priceHtml += boostPFSConfig.label.sold_out;
			priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		}
		priceHtml += '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '<div class="price__sale">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.sale_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item-mina-card line-thr" data-sale-price>';
		priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat);
		priceHtml += '</span> ';
		priceHtml += '<span class="price-item-mina-card" aria-hidden="true">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '</dl>';
	
		return priceHtml;
	}

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
	
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}
	
		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Build page items
		var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
              		var selected = Globals.queryParams.sort == k ? 'selected ' : '';
					sortingItemsHtml += '<option value="' + k + '" ' + selected + '>' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};
  
  	ProductSorting.prototype.bindEvents = function () {
		var _this = this;
		jQ(Selector.topSorting + ' select').change(function(event) {
			// Append "sort" param to url
			// Used to Scroll to the previous position after returning from Product page
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		})
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
		setTimeout(boostPFSFillPendingBadges, 0);
	};
  
  	// Only send Weglot request if the current language is different from English
function isWeglotActive() {
    if (!window.Weglot || !window.Weglot.initialized) {
      	return false;
    } else {
    	var currentLang = Weglot.getCurrentLang();
	// Change 'en' to suitable with original language of the store
    	return currentLang !== 'en';
    }
}
    
FilterApi.beforeCallAsync = function(callFilterApi) {
    // Then use it in our API
    if (Utils.isSearchPage() && window.Weglot && window.Weglot.initialized && isWeglotActive()) {
          Weglot.search(Utils.getSearchTerm(), function(englishTerm) {
              	Globals.queryParams['q'] = englishTerm;
              	callFilterApi();
          });
    } else {
          callFilterApi();
    }
}
})();